export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../assets/images/jobs/job-banner.jpg'),
        title: 'discover. experience. apply.',
        description: '',
        component: ''
      }
  ],
  applyNow: 'Apply Now',
  offer:[
    {
      icon: require('../../assets/images/jobs/job-icon-1.png'),
      title: 'flexible working hours',
      description: 'You can arrange when would you like to work in the day. It is possible to do home-office.'
    },
    {
      icon: require('../../assets/images/jobs/job-icon-2.png'),
      title: 'Referral bonuses',
      description: 'Good people know good people: utilize your network and help us find the right person for the job.'
    },
    {
      icon: require('../../assets/images/jobs/job-icon-3.png'),
      title: 'work-life balance',
      description: 'We have 5 weeks full-paid holidays.'
    },
    {
      icon: require('../../assets/images/jobs/job-icon-4.png'),
      title: 'learning & technology',
      description: 'We will provide you joining conferences and testing the new technology for improving your knowledge.'
    }
  ],
  jobs:[
    {
      title: 'Software Testing',
      address: 'Chengdu,China',
      description: `
      4k-6k / Chengdu / Experience 1-3 years / College and above / Full time <br/>
      Job responsibilities:<br/>
      1. Responsible for the testing of mobile APP, website and related products to ensure product quality<br/>
      2. Conduct test requirement analysis, use case design, test execution, develop test plans and test strategies, and write test reports;<br/>
      3. Suggest improvements to the test process to improve test efficiency.<br/>
      4. Ensure the test schedule, and risk estimation;<br/>
      5. Ensure the stable operation of the website after the release of program version;<br/>

      Skill requirements:<br/>
      1. Experience in website and mobile application software testing, including Android, iOS and other mobile platform testing experience;<br/>
      2. Familiar with software engineering, software testing theory and methods, familiar with relevant testing procedures, test documentation standards and software engineering principles;<br/>
      3. Proficient in software testing methods and techniques, can independently develop test plans, test cases, test specifications, and can prepare standardized test documents;<br/>
      4. Love testing work, have excellent learning, communication and coordination skills, have a good sense of teamwork;<br/>
      5. Strong logical thinking ability, good ability to analyze and summarize problems and good communication skills.
`,
      component: ''
    },
    {
      title: 'AI Engineer',
      address: 'Zhuhai,China',
      description: `
      12k-24k/Zhuhai/3-5 years of experience/master's degree or above/full-time<br/>
      Job responsibilities:<br/>
      1. Engaged in research and development of frontier algorithms in the field of artificial intelligence, technology-driven, and exploring innovative applications of artificial intelligence;<br/>
      2. Starting from specific scenarios and problems, research and develop algorithm system and output solutions;<br/>
      3. Build an artificial intelligence platform and endow more products with the ability of intelligent services.<br/>

      Job requirements:<br/>
      1. Professional background in mechanical engineering, computer science and mathematical statistics, Master's degree or above, Ph.D. preferred;<br/>
      2. In-depth research or senior working experience in at least one of the following fields: deep learning, natural language processing, search/recommendation algorithm, knowledge representation and reasoning, question-and-answer systems, image recognition, statistical machine learning;<br/>
      3. Familiar with Hadoop, Spark, Caffe, Tensorflow and other open source communities, with practical development experience being preferred;<br/>
      4. Familiar with Python and Java;<br/>
      5. Strong learning ability, good communication skills and passionate for technological innovation.`
    },
    {
      title: 'Android Development Engineer',
      address: 'Chengdu,China',
      description: `
      8k-15k/Chengdu/3-5 years of experience/Bachelor degree or above/Full-time<br/>
      Job description:<br/>
      1. Recruitment of an Android Mobile Development Software Engineer<br/>
      2. Has to be familiar with Android development technology, client code optimization and version management tools;<br/>
      3. Front-end HTML 5, react development experience is preferred;<br/>
      4. Familiar with Android application development architecture, system resource allocation and scheduling, client code optimization;<br/>
      5. Preferred 3 years or more of project development experience; full-time undergraduate and related professional graduates are preferred;<br/>
      6. Good learning ability, communication skills, teamwork spirit
      `
    },
    {
      title: 'BI Engineer (Big Data)',
      address: 'Chengdu,China',
      description: `
      8k-15k/Chengdu/Experience 3-5 years/College and above/Full-time<br/>
      Job description:<br/>
      Building a professional MIS system for professional companies, using Hadoop, ETL and other tools to provide services such as: big data analysis, accounting, performance appraisal, operation and management, etc., which requires long-term stable personnel.<br/>
      1. Familiar with HADOOP platform, and HIVE.<br/>
      2. Proficient in database knowledge, excellent SQL technology skills, and proficient in Oracle technology.<br/>
      3. Familiar with using ETL-related tools such as DATASATE/KETTLE and COGNOS.<br/>
      4. Better experience with PARP, TABLEAU and Pentaho BI tools<br/>
      5. Ability to bear hardships, hard working, do things conscientiously and responsibly<br/>
      6. Strong understanding and good communication skills<br/>
      7. 2 years or above of relevant work experience
      `
    },
    {
      title: 'C/C   Development Engineer',
      address: 'Chengdu,China',
      description: `
      20k-30k/Shanghai/3-5 years of experience/Bachelor degree or above/Full-time<br/>
      Job description:<br/>
      Experience in embedded software development<br/>
      Very good C programming and debugging skills<br/>
      RTOS experience is a plus<br/>
      Good understanding of the internal structure of the Linux operating system, IPC, and multi-threading.<br/>
      C, Python scripts shell knowledge, is a plus<br/>
      Familiar with using open source software packages<br/>
      Operating system: Linux / Android. Proficient in real-time multi-threaded software design and development, using IPC, synchronous primitive system programming<br/>
      Tools: Development and debugging of host-target tool chain using embedded platform<br/>
      Positive working attitude (dynamic) and good communication skills
      `
    },
    {
      title: 'Junior C Software Engineer',
      address: 'Chengdu,China',
      description: `
      6k-8k/Chengdu/1-3 years of experience/Bachelor degree or above/Full-time<br/>
      Job responsibilities:<br/>
      At least 2 years experience in C program development based on UNIX platform, and familiar with AIX/LINUX, Shell and database<br/>
      Requirements:<br/>
      At least 2 years of relevant work experience, able to provide academic qualifications, able to provide bachelor's degree certification and academic letter network inquiry
      `
    },
    {
      title: 'Natural Language Processing Engineer (NLP)',
      address: 'Chengdu,China',
      description: `
      10k-20k/Chengdu/3-5 years of experience/ Academic qualifications /full-time<br/>
      Job responsibilities:<br/>
      1. Research cutting-edge technologies in the field of natural language processing.<br/>
      2. From the perspective of system application, using the theory and methods of natural language processing to solve practical problems.<br/>
      3. Feature mining, clustering classification, similarity calculation, association mining and semantic analysis for unstructured texts.<br/>
      4. Ability to quickly propose solutions based on problem needs, combined with relevant cutting-edge technologies, and quickly build demonstration systems.<br/>

      Job requirements:<br/>
      1. Proficiency in basic theories and methods in the field of natural language processing, and also have relevant research or project experience.<br/>
      2. Familiar with current hotspots and cutting-edge technologies in the NLP field, and have a complete and systematic understanding of NLP.<br/>
      3. Familiar with Java language programming, familiar with Linux working environment, have a deep understanding of data structure and algorithm design.<br/>
      5. Excellent analytical and problem solving skills, passionate about solving challenging problems.<br/>
      6. Be hardworking, good at communication and good teamwork skills.
      `
    },
    {
      title: 'C Language Lecturer',
      address: 'Chengdu,China',
      description: `
      3k-4k/Chengdu/Experience 1-3 years/College and above/Part-time<br/>
      Job Requirements:<br/>
      1. Proficiency in C language;<br/>
      2. Abundant project experience in C language.
      `
    },
    {
      title: 'Senior Instant Messaging Engineer',
      address: 'Chengdu,China',
      description: `
      15k-30k/Chengdu/5-10 years of experience/Academic qualifications/full-time<br/>
      Job responsibilities:<br/>
      1. Responsible for the design, development and optimization of instant messaging (IM) system architecture;<br/>
      2. Responsible for the development of instant messaging software on mobile and PC.<br/>
      3. Cooperate with Android, iOS and Web developers to complete the docking with the IM system.<br/>
      4. Complete the design, development and programming tasks of the core module software according to the development schedule and task assignment.<br/>
      5. Responsible for the development of server functions based on instant messaging and message push.<br/>
      6. Responsible for Java background development work;<br/>

      Qualifications:<br/>
      1. Academic qualifications, major in computer software or related field, more than 5 years of Java development experience;<br/>
      2. Proficient in Java, solid programming foundation, familiar with IO, multithreading, concurrency and other basic frameworks, familiar with caching and distributed system development;<br/>
      3. Familiar with TCP/IP protocol, socket and multi-threaded development, familiar with common network programming framework, with high concurrency. Experience in large volume system development;<br/>
      4. Familiar with cloud computing related platforms and technologies;<br/>
      5. Good communication and learning skills, teamwork spirit, ability to adapt to strong work pressure, proactive work, serious and responsible, with strong management skills;
      `
    },
    {
      title: 'HTML 5',
      address: 'Chengdu,China',
      description: `
      10k-15k/Chengdu/Experience 3-5 years/College and above/Full-time<br/>
      Job description:<br/>
      1. Educational background College Degree or above <br/>
      2. Work experience Three years or more work experience<br/>
      3. Job responsibilities<br/>
      * responsible for the development of the company's product mobile client, familiar with HTML5 features and various JS frameworks, to achieve the interaction effect required by the product;<br/>
      * Participate in the construction and technical upgrading of HTML5 team;<br/>
      * Responsible for front-end development work, design and optimize the front-end basic service architecture;<br/>
      * Responsible for communicating with the company's product department and back-end technology;<br/>
      * Have knowledge of Hybrid app development.<br/>

      4. Technical abilities<br/>
      * Years of experience in web client script development and architecture design, proficient in a client-side scripting framework;<br/>
      * Proficient in HTML5, Java SCRIPT, CSS3, Jquery, Extjs, bootstrap, angular JS, etc., proficient in AJAX function design;<br/>
      * Ability to efficiently cut graphs, write html, div, css, JS files, and make compatible debugging and modification for all major browsers.<br/>
      * Self-motivated and good teamwork ability, able to work independently while under great pressure.<br/>
      * Understanding iOS, Android Mobile Platform Web Development Technology Standards;<br/>
      * Learn about at least one website back-end development tool, such as php/python-django.<br/>
      * Experience in smartphone and tablet development is preferred. Experience in JQuery Mobile, Angular JS, Sencha Touch, iWebkit and other frameworks is also preferred.
      `
    },
    {
      title: 'ICT Pre-Sales Engineer',
      address: 'Chengdu,China',
      description: `
      2001-4000 yuan/month 1-3 years/junior College<br/>
      Job information<br/>
      1. Responsible for organizing the preparation of project technical solutions, preparation of tenders, explanations and user Q&A.<br/>
      2. Cooperate with the account manager to complete technical communication with the user, program presentation, application system demonstration, etc.<br/>
      3. Cooperate with business departments to do user communication, demand feedback, technical coordination, etc.<br/>
      4. Cooperate with market personnel to complete application system demonstration, product data writing, etc.<br/>
      5. Cooperate with partners to exchange technology.<br/>
      6. Provide regular analysis plans for industries, markets, user needs, competitors, etc., and provide advice for the company's market direction, product development and software development.
      `
    },
    {
      title: 'Technical Manager (IM/Architecture)',
      address: 'Chengdu,China',
      description: `
      12k-20k/Chengdu/Experience 5-10 years/College and above/Full-time<br/>
      Job description:<br/>
      1. Solid Java foundation and familiar with design patterns;<br/>
      2. Participated in network communication, model, working mode, familiar with mina/netty;<br/>
      3. Familiar with distributed programming principles, such as dubbo, hazelcast, deep understanding of load balancing, message queuing, multi-thread processing, etc.<br/>
      4. Familiar with one or more nosqls, such as mongodb hbase, spark, storm, etc.<br/>
      5. Familiar with common development tools such as Git, Maven, Jenkins, etc.<br/>
      6. Social or large-scale product development experience is preferred;<br/>
      7. 5 years or above of working experience, experience in instant messaging development, familiarity with search engine is preferred.
      `
    },
    {
      title: 'Advanced iOS',
      address: 'Chengdu, China',
      description: `
      10k-15k/Chengdu/3-5 years of experience/unlimited education/full-time<br/>
      [Job Responsibilities]<br/>
      1. Responsible for the design, development and maintenance of iOS terminal products<br/>
      2. Responsible for the release, management and communication of the company's APP on the APP Store.<br/>

      [Job Requirements]<br/>
      1. 3 years or above experience in iOS client development<br/>
      2. Solid Objective-C programming foundation and good programming habits<br/>
      3. Familiar with iOS development technology and tools<br/>
      4. Familiar with iOS application development framework, able to independently develop high-performance iOS applications<br/>
      5. Unique insights and understanding of UI/UE of terminal products, pursuing the ultimate user experience<br/>
      6. Online works are preferred<br/>
      7. Persons with independent project experience are preferred
      `
    },
    {
      title: 'iOS Development Engineer',
      address: 'Chengdu,China',
      description: `
      8k-15k/Chengdu/3-5 years of experience/Bachelor degree or above/Full-time<br/>
      Job description:<br/>
      1. Responsible for the design and development of iOS applications according to business needs;<br/>
      2. According to the product function module design, independently complete the iOS software development and coding to realize the functions of each module to ensure development quality;<br/>
      3. Research the iOS platform development technology and propose improvements to the product based on experience, during the development process.<br/>

      Recruitment requirements:<br/>
      1. Computer related professional degree, two years or more experience in iOS platform development; able to read English documents, good at learning new skills;<br/>
      2. Familiar with Objective-c language development, familiar with the underlying implementation mechanism of CocoaTouch framework and iOS SDK, proficient in using XCode, InterfaceBuilder, Instruments and other development tools;<br/>
      3. Have a rich experience in IM and socket development (instant messaging);<br/>
      4. Knowledge of Java technology;<br/>
      5. iPhone, iPad successful case development experience is preferred;<br/>
      6. Can accept overtime.
      `
    },
    {
      title: 'Java development manager',
      address: 'Chengdu,China',
      description: `
      12k-16k/Chengdu/3-5 years of experience/Bachelor degree or above/Full-time<br/>
      Job responsibilities:<br/>
      1. Lead a team of 6-8 people to develop and test.<br/>
      2. Database design, object-oriented design and structure-oriented design;<br/>
      3. Complete the development of the software according to the design document;<br/>
      4. Responsible for writing software change instructions, functional features and other development documents;<br/>
      5. Responsible for organizing or coordinating the testing of projects and products.<br/>

      Job requirements:<br/>
      1. Bachelor degree or above in computer related major;<br/>
      2. At least 5 years of software development work experience, 3 years J2EE practical project experience, participated in at least 2 J2EE large and medium-sized projects, and have successful experience in developing B/S structure software (requiring successful cases);<br/>
      3. Proficiency in Java, proficient in J2EE technology and principles, proficient in using Java, HTML, Java Script, JSP, XML;<br/>
      4. At least two kinds of development experience in Struts, Spring, Hibernate and Ibatis, familiar with MVC programming mode;<br/>
      5. Familiar with Oracle, Sql Server and other large relational databases, have experience in database design, ability to guide the development and testing of database programs;<br/>
      6. Familiar with weblogic, Tomcat and other mainstream WEB servers, and have experience in using them.<br/>
      7. Object-oriented analysis, design and development (OOA, OOD, OOP) capabilities, master UML modeling skills, and able to use PowrDesigner and other modeling tools;<br/>
      8. Strong logical analysis ability, strong sense of responsibility and team spirit, good quality awareness, document writing ability;<br/>
      9. Age around 30 is preferred. Experience in business development in the financial field is also preferred.
      `
    },
    {
      title: 'PHP',
      address: 'Chengdu,China',
      description: `
      8k-13k/Chengdu/Experience 3-5 years/College and above/Full-time<br/>
      Job responsibilities:<br/>
      1. Responsible for the design and program development, unit testing and document writing of e-commerce project application and functional modules.<br/>
      2. Develop high-performance data and application services using the PHP language;<br/>
      3. Undertaking or participating in project needs analysis, design and implementation;<br/>
      4. Identifying problems in development and actively participate in the improvement of product, function and technical architecture.<br/>
      5. Complete the technical design and coding implementation of the e-commerce platform system/module according to the product requirements.<br/>

      Job Requirements:<br/>
      1. Familiar with Internet related technologies, with more than 3 years of project development experience.<br/>
      2. Proficient in PHP programming and have experience in developing large-scale Web applications.<br/>
      3. Familiar with PHP caching technology, query optimization and storage optimization experience.<br/>
      4. Proficiency in Web front-end technologies such as html, ajax, div   css, javascript, jquery, etc.<br/>
      5. Proficient in SQL syntax, familiar with MySQL database, familiar with commonly used database optimization strategies.<br/>
      6. Familiar with program development based on MVC mode, with OOP coding habits.<br/>
      7. Familiar with at least one framework development such as ThinkPHP and Yii.<br/>
      8. Have a good understanding of high concurrency and high load architecture.<br/>
      9. Have a comprehensive understanding of Internet technology and ability to independently cope with the design and development of websites with large number visits<br/>
      10. Experience in high performance business, distributed and caching technology .<br/>
      11. The ability to read and write e-mail in English<br/>
      12. Familiarity with the CodeIgniter framework is preferred.
      `
    },
    {
      title: '.NET',
      address: 'Chengdu,China',
      description: `
      6k-10k/Chengdu/Experience 1-3 years/College or above/Full-time<br/>
      Job description:<br/>
      1. Computer related majors<br/>
      2. Familiar with .NET related technology, proficient in C# language, proficient in ASP, .NET MVC<br/>
      3. Familiar with WEB technology, proficient in HTML, CSS, JavaScript<br/>
      4. Familiar with Oracle, SQL Server and other mainstream database development<br/>
      5. More than 2 years of development experience, having participated in the research and development of at least one complete project<br/>
      6. Understanding of software engineering, good teamwork skills, and e-commerce experience is preferred
      `
    },
    {
      title: 'Project Manager',
      address: 'Chengdu,China',
      description: `
      10k-18k/Chengdu/3-5 years of experience/Bachelor degree or above/Full-time<br/>

      Job responsibilities:<br/>
      1. In accordance with the company's project management norms, responsible for the overall project research, development and implementation of the project, project life cycle management;<br/>
      2. Understand the overall needs of the project and keep in touch with customers. Provide feedback of the periodic results in a timely manner and perform necessary changes based on the needs put forward by the demanders.<br/>
      3. Perform demand analysis and detailed design and module implementation according to project specifications;<br/>
      Develop project development plan documents, quantify tasks, and assign them to the appropriate personnel;<br/>
      5. Prepare project communication and reporting plans, and guide customers to define project scope;<br/>

      Job Requirements:<br/>
      1. Computer, software engineering and other related majors, with bachelor degree or above, more than three years of work experience and more than two years of project management experience;<br/>
      2. Proficient in Oracle database or other mainstream databases, and ability to perform database tuning according to project conditions;<br/>
      3. Proficiency in front-end design tools such as jQuery, XML, Json, proficiency in Java language and proficiency in Eclipse;<br/>
      4. Has good project planning, demand control, schedule control, risk management capabilities, undertake project needs analysis, planning, design and document conversion work;<br/>
      5. Excellent oral and written communication skills, able to communicate with customers at multiple levels;<br/>
      6. Familiar with project management theory, rich experience in project scope, time, personnel, cost and quality management, and posses good management, organization, communication, coordination and cooperation capabilities;<br/>
      7. Has strong document writing ability, can independently make standardized development process documents according to project requirements;<br/>
      8. Familiar with software development life cycle and management, and strictly abide by the standardized software development process, full of sense of responsibility and team spirit, proactive and responsible.
      `
    },
    {
      title: 'Oracle Engineer',
      address: 'Chengdu,China',
      description: `
      5000-7000 yuan/month Chengdu/experience not strict/undergraduate course<br/>

      Job information<br/>
      1. Writing Storage Procedures and Triggers<br/>
      2. Operation of Oracle under Unix<br/>
      3. Basic requirements of Oracle development: importing and exporting data, shell script<br/>
      4. Minimum pl, SQL development (basic) knowledge<br/>
      5. Foreign Language Reading and Writing Ability at good level
      `
    },
    {
      title: '.Net Intermediate and Senior Software Engineers',
      address: 'Chengdu,China',
      description: `
      10k-15k/Chengdu/Experience 5-10 years/Bachelor degree or above/Full-time<br/>

      Job description:<br/>
      First: belong to project assignment<br/>
      Second: Job description:<br/>
      1. Responsible for software design and development, testing, debugging, system maintenance;<br/>
      2. Familiar with C#, CSS, JavaScript, HTML5, jQuery, winform, web and other development technologies;<br/>
      3. Familiar with sql2008R2;<br/>
      4. Familiar with Mvc, angularjs, HTML 5, VB, C++ language development experience is preferred.
      `
    },
    {
      title: 'Network Security R&D Manager',
      address: 'Chengdu,China',
      description: `
      13k-26k/Chengdu/5-10 years of experience/Academic qualifications /full-time<br/>

      Job Responsibilities<br/>
      1. Participate in the design and development of software projects, including requirements analysis, system design, coding and unit testing.<br/>
      2. Ability to independently complete business design and related technology implementation;<br/>
      3. Complete maintenance of the system, including functional improvement, system optimization and technical support;<br/>
      4. Proactively consider the business needs, system status and problems, plan and implement the development of the system.<br/>
      5. Participate in the research and development of the key and difficult modules of the project, and provide the overall business-oriented optimization scheme according to the characteristics of the business.<br/>
      6. Responsible for mobile and Internet of Things security, planning, information security service project development and management;<br/>
      7. Be able to take the initiative to pay attention to the latest security attack and defense technology at home and abroad, and be able to conduct in-depth study and research in areas where they are good at and interested.<br/>
      8. Have knowledge and research on several aspects such as Web security, server security, client security, mobile security, wireless security, and Internet of Things security;<br/>
      9. Assist in managing network intrusion detection engine and product development process<br/>

      Job Requirements:<br/>
      1. Good English listening, speaking, reading and writing skills, more than 4 years of Java development experience, rich project experience, and independent or leading the completion of at least 2 projects, with rich project experience (especially in network security design)<br/>
      2. Excellent database design and optimization capabilities, at least proficient in a commonly used relational database, proficient in Oracle database development is a priority;<br/>
      3. Familiar with Java EE related technologies and frameworks (including Java language, multithreading, Spring, Hibernate, iBatis, Cache, Messaging, Workflow, struts 2, etc.)<br/>
      4. Proficiency in Linux, Shell and Python<br/>
      5. Strong learning ability, excellent logical thinking ability, good communication skills, good sense of time and process awareness; able to quickly integrate into the team;<br/>
      6. Work experience in the field of network security is preferred;<br/>
      7. National Information System Project Manager and PMP certification are preferred.
      `
    },
    {
      title:'Python Engineer',
      address: 'Chengdu,China',
      description: `
      8k-15k/Chengdu/Experience 1-3 years/College or above/Full-time<br/>

      Job responsibilities:<br/>
      1. Functional design, development and implementation of cloud computing products based on Django;<br/>
      2. Cloud computing, research on cutting-edge technologies such as Django and research on new technology frameworks<br/>

      Job requirements:<br/>
      1. Bachelor's degree or above in computer and related fields;<br/>
      2. Proficient in Python language, familiar with one of the web frameworks such as Django, tornado, web.py, etc.<br/>
      3. Familiar with HTML/HTML5, CSS, JavaScript, JQuery, at least one web framework<br/>
      4. Proficient in using Linux system, have a strong understanding of algorithms, data structures and background development (C/C  /PHP/Java, etc.).<br/>
      5. Strong understanding of cloud computing, willing to further study and learn in the field of cloud computing<br/>
      6. Strong enterprising spirit, good learning ability, good communication and expression skills, clear thinking, strong practical ability and logical analysis ability
      7. Passionate about work and life<br/>
      8. The following conditions are preferred:<br/>
      A) Strong interest and hobbies in open source technology, participation or submission of bugs and patches to developers
      `
    },
    {
      title: 'Big Data Software Engineer',
      address: 'Chengdu,China',
      description: `
      8k-10k/Chengdu/Experience 1-3 years/Bachelor degree or above/Full-time<br/>

      Job description:<br/>
      1. Master the knowledge of software engineering and related financial business, and be proficient in using mainstream big data technologies such as HDFS/MR/HBase/Hive/Spark, and can independently complete the development of HBase/Hive/Spark/Kafka.<br/>
      2. Master the knowledge of database, software and banking business, and be proficient in JAVA and SQL
      `
    },
    {
      title: 'UI Designer',
      address: 'Chengdu,China',
      description: `
      7k-10k/Chengdu/Experience 1-3 years/College or above/Full-time<br/>

      Job Responsibilities<br/>
      *Responsible for the company's external design, revision, update;<br/>
      *Responsible for the design, editing and beautification of the company's product interface.<br/>
      *Carry out artistic design for the company's promotional products.<br/>
      *Responsible for working with the developer to complete the design and editing of the front page such as the website under its jurisdiction;<br/>
      *Other work related to art design.<br/>

      Technical skills<br/>
      *Major in Fine Arts, Graphic Design or related majors, College or above;<br/>
      *More than two years experience in web design and graphic design;<br/>
      *Have solid art background, good creative thinking and understanding ability, can grasp customer needs in a timely manner;<br/>
      *Proficient in design software such as Photoshop\Dreamweaver, have a good understanding of image rendering and visual effects;<br/>
      *Good at communicating with people, good team spirit and high sense of responsibility, able to withstand pressure, innovative spirit, to ensure the quality of work.
      `
    },
    {
      title: 'Senior Web Development Engineer',
      address: 'Chengdu,China',
      description: `
      10k-15k/Chengdu/3-5 years of experience/Academic qualifications /full-time<br/>

      Job responsibilities:<br/>
      Job requirements: Responsible for the development and maintenance of enterprise web application system!<br/>
      Experience Requirements: More than 6 years of relevant experience<br/>
      Skill requirements:<br/>
      Good technical capability in the following: Java JavaEE JSP spring framework JavaScript pl/sql<br/>

      Things to keep in mind before applying:<br/>
      1. Spring boot development experience is required, familiarity with Spring boot related application development setup and deployment and mainstream OPM framework <br/>
      2. Experience in RESatful web service development and experience in REST-style API design and framework<br/>
      3. Spring experience in distributed systems or micro-services architecture and development
      Cloud or Dubbo framework configuration and development services (microservice direction)
      Excellent English reading and email processing skills, good oral English skills
      Excellent analytical problem solving and conceptual analysis reasoning skills
      Ability to work under pressure to meet deadlines
      Ability to work independently, and strong team spirit skills
      Ability to follow code rules and procedures!
      `
    }
  ]

}
